export const getTimeAgo = (unixTimestamp) => {
	const now = Date.now();
	const notificationDate = unixTimestamp * 1000; // Convertir a milisegundos
	const diff = now - notificationDate;

	const minutes = Math.floor(diff / (1000 * 60));
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(hours / 24);
	const weeks = Math.floor(days / 7);

	if (minutes < 5) return 'Ahora';
	if (minutes < 60) return `${minutes} minuto${minutes !== 1 ? 's' : ''}`;
	if (hours < 24) return `${hours} hora${hours !== 1 ? 's' : ''}`;
	if (days <= 7) return `${days} día${days !== 1 ? 's' : ''}`;
	if (weeks < 4) return 'más de una semana';

	return 'más de 1 mes';
};
